if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        const idInput = this.form ? this.form.querySelector('[name=id]') : null;
        if (idInput) idInput.disabled = false;

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const cartAddUrl = (window.routes && window.routes.cart_add_url) || (typeof routes !== 'undefined' && routes.cart_add_url) || '/cart/add';
        const cartUrl = (window.routes && window.routes.cart_url) || (typeof routes !== 'undefined' && routes.cart_url) || '/cart';

        const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
          method: 'POST',
          headers: { Accept: 'application/javascript' }
        };
        config.headers = config.headers || {};
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        let productVariantId = formData.get('id') ||
          (this.form.querySelector('[name="id"]')
            ? this.form.querySelector('[name="id"]').value
            : null);

        let mainQty = formData.get('quantity') ||
          (this.form.querySelector('[name="quantity"]')
            ? this.form.querySelector('[name="quantity"]').value
            : '1');

        let sellingPlanId = formData.get('selling_plan') ||
          (this.form.querySelector('[name="selling_plan"]')
            ? this.form.querySelector('[name="selling_plan"]').value
            : null);

        let targetUrl = `${cartAddUrl.replace(/\.js$/, '')}.js`;

        // Check for optional SIM addon checkbox
        const addonCheckbox = this.form.querySelector('input[type="checkbox"][data-variant-id]');
        if (addonCheckbox && addonCheckbox.checked) {
          const addonVariantId = addonCheckbox.getAttribute('data-variant-id');
          const addonSellingPlanId = addonCheckbox.getAttribute('data-selling-plan-id');

          config.headers['Content-Type'] = 'application/json';
          config.headers['Accept'] = 'application/json';

          const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];

          const mainItem = {
            id: productVariantId ? parseInt(productVariantId, 10) : null,
            quantity: parseInt(mainQty, 10) || 1
          };

          if (sellingPlanId) {
            mainItem.selling_plan = parseInt(sellingPlanId, 10);
          }

          const addonItem = {
            id: addonVariantId ? parseInt(addonVariantId, 10) : null,
            quantity: 1
          };

          if (addonSellingPlanId) {
            addonItem.selling_plan = parseInt(addonSellingPlanId, 10);
          }

          config.body = JSON.stringify({
            items: [
              mainItem,
              addonItem
            ],
            sections: sections,
            sections_url: window.location.pathname
          });

          if (this.cart) {
            this.cart.setActiveElement(document.activeElement);
          }
        } else {
          if (this.cart) {
            if (sellingPlanId && !formData.get('selling_plan')) {
              formData.append('selling_plan', sellingPlanId);
            }
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
            targetUrl = cartAddUrl;
            config.body = formData;
          } else {
            // Send as JSON to /cart/add.js
            config.headers['Content-Type'] = 'application/json';
            config.headers['Accept'] = 'application/json';

            const item = {
              id: productVariantId ? parseInt(productVariantId, 10) : null,
              quantity: parseInt(mainQty, 10) || 1
            };

            if (sellingPlanId) {
              item.selling_plan = parseInt(sellingPlanId, 10);
            }

            config.body = JSON.stringify(item);
          }
        }

        fetch(targetUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status && response.status >= 400) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: productVariantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.handleErrorMessage(response.description || response.message || 'Error adding item to cart');

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                const buttonSpan = this.submitButton.querySelector('span');
                if (buttonSpan) buttonSpan.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = cartUrl;
              return;
            }

            if (!this.error && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: productVariantId, cartData: response });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (this.cart && typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error('Add to cart error:', e);
            this.handleErrorMessage('Something went wrong. Please try again.');
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            const spinnerEl = this.querySelector('.loading-overlay__spinner');
            if (spinnerEl) spinnerEl.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || this.querySelector('.gd-buy__error');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message') || this.errorMessageWrapper;

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
